import { g as St, a as $e, _ as oe, p as i } from "./createTheme-02ce03eb.js";
import * as V from "react";
import { j as xe, a as Mt } from "./useTheme-efe1290c.js";
import { s as Nt } from "./styled-38387a7e.js";
import { g as Ct, a as Qe, c as kt, u as Bt } from "./useThemeProps-ee4acb93.js";
import { P as $t, H as Ee, u as Lt } from "./Portal-9153c320.js";
import { o as Ze } from "./ownerDocument-5430cd5b.js";
import { c as Vt } from "./chainPropTypes-004bf492.js";
import { r as ut } from "./refType-e39501b1.js";
import { a as et } from "./useEventCallback-fe4fd69c.js";
import { u as It } from "./useSlotProps-5893c531.js";
var N = "top", I = "bottom", W = "right", C = "left", Te = "auto", me = [N, I, W, C], ne = "start", de = "end", Wt = "clippingParents", dt = "viewport", ce = "popper", qt = "reference", tt = /* @__PURE__ */ me.reduce(function(t, e) {
  return t.concat([e + "-" + ne, e + "-" + de]);
}, []), vt = /* @__PURE__ */ [].concat(me, [Te]).reduce(function(t, e) {
  return t.concat([e, e + "-" + ne, e + "-" + de]);
}, []), Ht = "beforeRead", Ut = "read", Ft = "afterRead", _t = "beforeMain", Xt = "main", Yt = "afterMain", zt = "beforeWrite", Gt = "write", Jt = "afterWrite", Ce = [Ht, Ut, Ft, _t, Xt, Yt, zt, Gt, Jt];
function X(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function L(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function te(t) {
  var e = L(t).Element;
  return t instanceof e || t instanceof Element;
}
function $(t) {
  var e = L(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function Le(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = L(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function Kt(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var o = e.styles[r] || {}, n = e.attributes[r] || {}, a = e.elements[r];
    !$(a) || !X(a) || (Object.assign(a.style, o), Object.keys(n).forEach(function(c) {
      var p = n[c];
      p === !1 ? a.removeAttribute(c) : a.setAttribute(c, p === !0 ? "" : p);
    }));
  });
}
function Qt(t) {
  var e = t.state, r = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(o) {
      var n = e.elements[o], a = e.attributes[o] || {}, c = Object.keys(e.styles.hasOwnProperty(o) ? e.styles[o] : r[o]), p = c.reduce(function(s, l) {
        return s[l] = "", s;
      }, {});
      !$(n) || !X(n) || (Object.assign(n.style, p), Object.keys(a).forEach(function(s) {
        n.removeAttribute(s);
      }));
    });
  };
}
const Zt = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Kt,
  effect: Qt,
  requires: ["computeStyles"]
};
function q(t) {
  return t.split("-")[0];
}
var ee = Math.max, Pe = Math.min, ae = Math.round;
function ke() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function mt() {
  return !/^((?!chrome|android).)*safari/i.test(ke());
}
function ie(t, e, r) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  var o = t.getBoundingClientRect(), n = 1, a = 1;
  e && $(t) && (n = t.offsetWidth > 0 && ae(o.width) / t.offsetWidth || 1, a = t.offsetHeight > 0 && ae(o.height) / t.offsetHeight || 1);
  var c = te(t) ? L(t) : window, p = c.visualViewport, s = !mt() && r, l = (o.left + (s && p ? p.offsetLeft : 0)) / n, f = (o.top + (s && p ? p.offsetTop : 0)) / a, y = o.width / n, O = o.height / a;
  return {
    width: y,
    height: O,
    top: f,
    right: l + y,
    bottom: f + O,
    left: l,
    x: l,
    y: f
  };
}
function Ve(t) {
  var e = ie(t), r = t.offsetWidth, o = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - o) <= 1 && (o = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: r,
    height: o
  };
}
function ht(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && Le(r)) {
    var o = e;
    do {
      if (o && t.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function H(t) {
  return L(t).getComputedStyle(t);
}
function er(t) {
  return ["table", "td", "th"].indexOf(X(t)) >= 0;
}
function J(t) {
  return ((te(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function je(t) {
  return X(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (Le(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    J(t)
  );
}
function rt(t) {
  return !$(t) || // https://github.com/popperjs/popper-core/issues/837
  H(t).position === "fixed" ? null : t.offsetParent;
}
function tr(t) {
  var e = /firefox/i.test(ke()), r = /Trident/i.test(ke());
  if (r && $(t)) {
    var o = H(t);
    if (o.position === "fixed")
      return null;
  }
  var n = je(t);
  for (Le(n) && (n = n.host); $(n) && ["html", "body"].indexOf(X(n)) < 0; ) {
    var a = H(n);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || e && a.willChange === "filter" || e && a.filter && a.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function he(t) {
  for (var e = L(t), r = rt(t); r && er(r) && H(r).position === "static"; )
    r = rt(r);
  return r && (X(r) === "html" || X(r) === "body" && H(r).position === "static") ? e : r || tr(t) || e;
}
function Ie(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function le(t, e, r) {
  return ee(t, Pe(e, r));
}
function rr(t, e, r) {
  var o = le(t, e, r);
  return o > r ? r : o;
}
function yt() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function bt(t) {
  return Object.assign({}, yt(), t);
}
function gt(t, e) {
  return e.reduce(function(r, o) {
    return r[o] = t, r;
  }, {});
}
var or = function(e, r) {
  return e = typeof e == "function" ? e(Object.assign({}, r.rects, {
    placement: r.placement
  })) : e, bt(typeof e != "number" ? e : gt(e, me));
};
function nr(t) {
  var e, r = t.state, o = t.name, n = t.options, a = r.elements.arrow, c = r.modifiersData.popperOffsets, p = q(r.placement), s = Ie(p), l = [C, W].indexOf(p) >= 0, f = l ? "height" : "width";
  if (!(!a || !c)) {
    var y = or(n.padding, r), O = Ve(a), u = s === "y" ? N : C, E = s === "y" ? I : W, m = r.rects.reference[f] + r.rects.reference[s] - c[s] - r.rects.popper[f], b = c[s] - r.rects.reference[s], x = he(a), j = x ? s === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, P = m / 2 - b / 2, v = y[u], h = j - O[f] - y[E], d = j / 2 - O[f] / 2 + P, w = le(v, d, h), R = s;
    r.modifiersData[o] = (e = {}, e[R] = w, e.centerOffset = w - d, e);
  }
}
function ar(t) {
  var e = t.state, r = t.options, o = r.element, n = o === void 0 ? "[data-popper-arrow]" : o;
  if (n != null && !(typeof n == "string" && (n = e.elements.popper.querySelector(n), !n))) {
    if (process.env.NODE_ENV !== "production" && ($(n) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !ht(e.elements.popper, n)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    e.elements.arrow = n;
  }
}
const ir = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: nr,
  effect: ar,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function se(t) {
  return t.split("-")[1];
}
var sr = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function pr(t, e) {
  var r = t.x, o = t.y, n = e.devicePixelRatio || 1;
  return {
    x: ae(r * n) / n || 0,
    y: ae(o * n) / n || 0
  };
}
function ot(t) {
  var e, r = t.popper, o = t.popperRect, n = t.placement, a = t.variation, c = t.offsets, p = t.position, s = t.gpuAcceleration, l = t.adaptive, f = t.roundOffsets, y = t.isFixed, O = c.x, u = O === void 0 ? 0 : O, E = c.y, m = E === void 0 ? 0 : E, b = typeof f == "function" ? f({
    x: u,
    y: m
  }) : {
    x: u,
    y: m
  };
  u = b.x, m = b.y;
  var x = c.hasOwnProperty("x"), j = c.hasOwnProperty("y"), P = C, v = N, h = window;
  if (l) {
    var d = he(r), w = "clientHeight", R = "clientWidth";
    if (d === L(r) && (d = J(r), H(d).position !== "static" && p === "absolute" && (w = "scrollHeight", R = "scrollWidth")), d = d, n === N || (n === C || n === W) && a === de) {
      v = I;
      var A = y && d === h && h.visualViewport ? h.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        d[w]
      );
      m -= A - o.height, m *= s ? 1 : -1;
    }
    if (n === C || (n === N || n === I) && a === de) {
      P = W;
      var T = y && d === h && h.visualViewport ? h.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        d[R]
      );
      u -= T - o.width, u *= s ? 1 : -1;
    }
  }
  var g = Object.assign({
    position: p
  }, l && sr), S = f === !0 ? pr({
    x: u,
    y: m
  }, L(r)) : {
    x: u,
    y: m
  };
  if (u = S.x, m = S.y, s) {
    var D;
    return Object.assign({}, g, (D = {}, D[v] = j ? "0" : "", D[P] = x ? "0" : "", D.transform = (h.devicePixelRatio || 1) <= 1 ? "translate(" + u + "px, " + m + "px)" : "translate3d(" + u + "px, " + m + "px, 0)", D));
  }
  return Object.assign({}, g, (e = {}, e[v] = j ? m + "px" : "", e[P] = x ? u + "px" : "", e.transform = "", e));
}
function fr(t) {
  var e = t.state, r = t.options, o = r.gpuAcceleration, n = o === void 0 ? !0 : o, a = r.adaptive, c = a === void 0 ? !0 : a, p = r.roundOffsets, s = p === void 0 ? !0 : p;
  if (process.env.NODE_ENV !== "production") {
    var l = H(e.elements.popper).transitionProperty || "";
    c && ["transform", "top", "right", "bottom", "left"].some(function(y) {
      return l.indexOf(y) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var f = {
    placement: q(e.placement),
    variation: se(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: n,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, ot(Object.assign({}, f, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: c,
    roundOffsets: s
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, ot(Object.assign({}, f, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const cr = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: fr,
  data: {}
};
var we = {
  passive: !0
};
function lr(t) {
  var e = t.state, r = t.instance, o = t.options, n = o.scroll, a = n === void 0 ? !0 : n, c = o.resize, p = c === void 0 ? !0 : c, s = L(e.elements.popper), l = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return a && l.forEach(function(f) {
    f.addEventListener("scroll", r.update, we);
  }), p && s.addEventListener("resize", r.update, we), function() {
    a && l.forEach(function(f) {
      f.removeEventListener("scroll", r.update, we);
    }), p && s.removeEventListener("resize", r.update, we);
  };
}
const ur = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: lr,
  data: {}
};
var dr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Oe(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return dr[e];
  });
}
var vr = {
  start: "end",
  end: "start"
};
function nt(t) {
  return t.replace(/start|end/g, function(e) {
    return vr[e];
  });
}
function We(t) {
  var e = L(t), r = e.pageXOffset, o = e.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: o
  };
}
function qe(t) {
  return ie(J(t)).left + We(t).scrollLeft;
}
function mr(t, e) {
  var r = L(t), o = J(t), n = r.visualViewport, a = o.clientWidth, c = o.clientHeight, p = 0, s = 0;
  if (n) {
    a = n.width, c = n.height;
    var l = mt();
    (l || !l && e === "fixed") && (p = n.offsetLeft, s = n.offsetTop);
  }
  return {
    width: a,
    height: c,
    x: p + qe(t),
    y: s
  };
}
function hr(t) {
  var e, r = J(t), o = We(t), n = (e = t.ownerDocument) == null ? void 0 : e.body, a = ee(r.scrollWidth, r.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), c = ee(r.scrollHeight, r.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), p = -o.scrollLeft + qe(t), s = -o.scrollTop;
  return H(n || r).direction === "rtl" && (p += ee(r.clientWidth, n ? n.clientWidth : 0) - a), {
    width: a,
    height: c,
    x: p,
    y: s
  };
}
function He(t) {
  var e = H(t), r = e.overflow, o = e.overflowX, n = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + n + o);
}
function wt(t) {
  return ["html", "body", "#document"].indexOf(X(t)) >= 0 ? t.ownerDocument.body : $(t) && He(t) ? t : wt(je(t));
}
function ue(t, e) {
  var r;
  e === void 0 && (e = []);
  var o = wt(t), n = o === ((r = t.ownerDocument) == null ? void 0 : r.body), a = L(o), c = n ? [a].concat(a.visualViewport || [], He(o) ? o : []) : o, p = e.concat(c);
  return n ? p : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    p.concat(ue(je(c)))
  );
}
function Be(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function yr(t, e) {
  var r = ie(t, !1, e === "fixed");
  return r.top = r.top + t.clientTop, r.left = r.left + t.clientLeft, r.bottom = r.top + t.clientHeight, r.right = r.left + t.clientWidth, r.width = t.clientWidth, r.height = t.clientHeight, r.x = r.left, r.y = r.top, r;
}
function at(t, e, r) {
  return e === dt ? Be(mr(t, r)) : te(e) ? yr(e, r) : Be(hr(J(t)));
}
function br(t) {
  var e = ue(je(t)), r = ["absolute", "fixed"].indexOf(H(t).position) >= 0, o = r && $(t) ? he(t) : t;
  return te(o) ? e.filter(function(n) {
    return te(n) && ht(n, o) && X(n) !== "body";
  }) : [];
}
function gr(t, e, r, o) {
  var n = e === "clippingParents" ? br(t) : [].concat(e), a = [].concat(n, [r]), c = a[0], p = a.reduce(function(s, l) {
    var f = at(t, l, o);
    return s.top = ee(f.top, s.top), s.right = Pe(f.right, s.right), s.bottom = Pe(f.bottom, s.bottom), s.left = ee(f.left, s.left), s;
  }, at(t, c, o));
  return p.width = p.right - p.left, p.height = p.bottom - p.top, p.x = p.left, p.y = p.top, p;
}
function Ot(t) {
  var e = t.reference, r = t.element, o = t.placement, n = o ? q(o) : null, a = o ? se(o) : null, c = e.x + e.width / 2 - r.width / 2, p = e.y + e.height / 2 - r.height / 2, s;
  switch (n) {
    case N:
      s = {
        x: c,
        y: e.y - r.height
      };
      break;
    case I:
      s = {
        x: c,
        y: e.y + e.height
      };
      break;
    case W:
      s = {
        x: e.x + e.width,
        y: p
      };
      break;
    case C:
      s = {
        x: e.x - r.width,
        y: p
      };
      break;
    default:
      s = {
        x: e.x,
        y: e.y
      };
  }
  var l = n ? Ie(n) : null;
  if (l != null) {
    var f = l === "y" ? "height" : "width";
    switch (a) {
      case ne:
        s[l] = s[l] - (e[f] / 2 - r[f] / 2);
        break;
      case de:
        s[l] = s[l] + (e[f] / 2 - r[f] / 2);
        break;
    }
  }
  return s;
}
function ve(t, e) {
  e === void 0 && (e = {});
  var r = e, o = r.placement, n = o === void 0 ? t.placement : o, a = r.strategy, c = a === void 0 ? t.strategy : a, p = r.boundary, s = p === void 0 ? Wt : p, l = r.rootBoundary, f = l === void 0 ? dt : l, y = r.elementContext, O = y === void 0 ? ce : y, u = r.altBoundary, E = u === void 0 ? !1 : u, m = r.padding, b = m === void 0 ? 0 : m, x = bt(typeof b != "number" ? b : gt(b, me)), j = O === ce ? qt : ce, P = t.rects.popper, v = t.elements[E ? j : O], h = gr(te(v) ? v : v.contextElement || J(t.elements.popper), s, f, c), d = ie(t.elements.reference), w = Ot({
    reference: d,
    element: P,
    strategy: "absolute",
    placement: n
  }), R = Be(Object.assign({}, P, w)), A = O === ce ? R : d, T = {
    top: h.top - A.top + x.top,
    bottom: A.bottom - h.bottom + x.bottom,
    left: h.left - A.left + x.left,
    right: A.right - h.right + x.right
  }, g = t.modifiersData.offset;
  if (O === ce && g) {
    var S = g[n];
    Object.keys(T).forEach(function(D) {
      var Y = [W, I].indexOf(D) >= 0 ? 1 : -1, U = [N, I].indexOf(D) >= 0 ? "y" : "x";
      T[D] += S[U] * Y;
    });
  }
  return T;
}
function wr(t, e) {
  e === void 0 && (e = {});
  var r = e, o = r.placement, n = r.boundary, a = r.rootBoundary, c = r.padding, p = r.flipVariations, s = r.allowedAutoPlacements, l = s === void 0 ? vt : s, f = se(o), y = f ? p ? tt : tt.filter(function(E) {
    return se(E) === f;
  }) : me, O = y.filter(function(E) {
    return l.indexOf(E) >= 0;
  });
  O.length === 0 && (O = y, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var u = O.reduce(function(E, m) {
    return E[m] = ve(t, {
      placement: m,
      boundary: n,
      rootBoundary: a,
      padding: c
    })[q(m)], E;
  }, {});
  return Object.keys(u).sort(function(E, m) {
    return u[E] - u[m];
  });
}
function Or(t) {
  if (q(t) === Te)
    return [];
  var e = Oe(t);
  return [nt(t), e, nt(e)];
}
function xr(t) {
  var e = t.state, r = t.options, o = t.name;
  if (!e.modifiersData[o]._skip) {
    for (var n = r.mainAxis, a = n === void 0 ? !0 : n, c = r.altAxis, p = c === void 0 ? !0 : c, s = r.fallbackPlacements, l = r.padding, f = r.boundary, y = r.rootBoundary, O = r.altBoundary, u = r.flipVariations, E = u === void 0 ? !0 : u, m = r.allowedAutoPlacements, b = e.options.placement, x = q(b), j = x === b, P = s || (j || !E ? [Oe(b)] : Or(b)), v = [b].concat(P).reduce(function(re, z) {
      return re.concat(q(z) === Te ? wr(e, {
        placement: z,
        boundary: f,
        rootBoundary: y,
        padding: l,
        flipVariations: E,
        allowedAutoPlacements: m
      }) : z);
    }, []), h = e.rects.reference, d = e.rects.popper, w = /* @__PURE__ */ new Map(), R = !0, A = v[0], T = 0; T < v.length; T++) {
      var g = v[T], S = q(g), D = se(g) === ne, Y = [N, I].indexOf(S) >= 0, U = Y ? "width" : "height", M = ve(e, {
        placement: g,
        boundary: f,
        rootBoundary: y,
        altBoundary: O,
        padding: l
      }), k = Y ? D ? W : C : D ? I : N;
      h[U] > d[U] && (k = Oe(k));
      var F = Oe(k), _ = [];
      if (a && _.push(M[S] <= 0), p && _.push(M[k] <= 0, M[F] <= 0), _.every(function(re) {
        return re;
      })) {
        A = g, R = !1;
        break;
      }
      w.set(g, _);
    }
    if (R)
      for (var B = E ? 3 : 1, De = function(z) {
        var fe = v.find(function(be) {
          var K = w.get(be);
          if (K)
            return K.slice(0, z).every(function(Se) {
              return Se;
            });
        });
        if (fe)
          return A = fe, "break";
      }, pe = B; pe > 0; pe--) {
        var ye = De(pe);
        if (ye === "break")
          break;
      }
    e.placement !== A && (e.modifiersData[o]._skip = !0, e.placement = A, e.reset = !0);
  }
}
const Er = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: xr,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function it(t, e, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - r.y,
    right: t.right - e.width + r.x,
    bottom: t.bottom - e.height + r.y,
    left: t.left - e.width - r.x
  };
}
function st(t) {
  return [N, W, I, C].some(function(e) {
    return t[e] >= 0;
  });
}
function Pr(t) {
  var e = t.state, r = t.name, o = e.rects.reference, n = e.rects.popper, a = e.modifiersData.preventOverflow, c = ve(e, {
    elementContext: "reference"
  }), p = ve(e, {
    altBoundary: !0
  }), s = it(c, o), l = it(p, n, a), f = st(s), y = st(l);
  e.modifiersData[r] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: l,
    isReferenceHidden: f,
    hasPopperEscaped: y
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": y
  });
}
const Rr = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Pr
};
function Tr(t, e, r) {
  var o = q(t), n = [C, N].indexOf(o) >= 0 ? -1 : 1, a = typeof r == "function" ? r(Object.assign({}, e, {
    placement: t
  })) : r, c = a[0], p = a[1];
  return c = c || 0, p = (p || 0) * n, [C, W].indexOf(o) >= 0 ? {
    x: p,
    y: c
  } : {
    x: c,
    y: p
  };
}
function jr(t) {
  var e = t.state, r = t.options, o = t.name, n = r.offset, a = n === void 0 ? [0, 0] : n, c = vt.reduce(function(f, y) {
    return f[y] = Tr(y, e.rects, a), f;
  }, {}), p = c[e.placement], s = p.x, l = p.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += s, e.modifiersData.popperOffsets.y += l), e.modifiersData[o] = c;
}
const Ar = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: jr
};
function Dr(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = Ot({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const Sr = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Dr,
  data: {}
};
function Mr(t) {
  return t === "x" ? "y" : "x";
}
function Nr(t) {
  var e = t.state, r = t.options, o = t.name, n = r.mainAxis, a = n === void 0 ? !0 : n, c = r.altAxis, p = c === void 0 ? !1 : c, s = r.boundary, l = r.rootBoundary, f = r.altBoundary, y = r.padding, O = r.tether, u = O === void 0 ? !0 : O, E = r.tetherOffset, m = E === void 0 ? 0 : E, b = ve(e, {
    boundary: s,
    rootBoundary: l,
    padding: y,
    altBoundary: f
  }), x = q(e.placement), j = se(e.placement), P = !j, v = Ie(x), h = Mr(v), d = e.modifiersData.popperOffsets, w = e.rects.reference, R = e.rects.popper, A = typeof m == "function" ? m(Object.assign({}, e.rects, {
    placement: e.placement
  })) : m, T = typeof A == "number" ? {
    mainAxis: A,
    altAxis: A
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, A), g = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, S = {
    x: 0,
    y: 0
  };
  if (d) {
    if (a) {
      var D, Y = v === "y" ? N : C, U = v === "y" ? I : W, M = v === "y" ? "height" : "width", k = d[v], F = k + b[Y], _ = k - b[U], B = u ? -R[M] / 2 : 0, De = j === ne ? w[M] : R[M], pe = j === ne ? -R[M] : -w[M], ye = e.elements.arrow, re = u && ye ? Ve(ye) : {
        width: 0,
        height: 0
      }, z = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : yt(), fe = z[Y], be = z[U], K = le(0, w[M], re[M]), Se = P ? w[M] / 2 - B - K - fe - T.mainAxis : De - K - fe - T.mainAxis, Pt = P ? -w[M] / 2 + B + K + be + T.mainAxis : pe + K + be + T.mainAxis, Me = e.elements.arrow && he(e.elements.arrow), Rt = Me ? v === "y" ? Me.clientTop || 0 : Me.clientLeft || 0 : 0, Ue = (D = g == null ? void 0 : g[v]) != null ? D : 0, Tt = k + Se - Ue - Rt, jt = k + Pt - Ue, Fe = le(u ? Pe(F, Tt) : F, k, u ? ee(_, jt) : _);
      d[v] = Fe, S[v] = Fe - k;
    }
    if (p) {
      var _e, At = v === "x" ? N : C, Dt = v === "x" ? I : W, Q = d[h], ge = h === "y" ? "height" : "width", Xe = Q + b[At], Ye = Q - b[Dt], Ne = [N, C].indexOf(x) !== -1, ze = (_e = g == null ? void 0 : g[h]) != null ? _e : 0, Ge = Ne ? Xe : Q - w[ge] - R[ge] - ze + T.altAxis, Je = Ne ? Q + w[ge] + R[ge] - ze - T.altAxis : Ye, Ke = u && Ne ? rr(Ge, Q, Je) : le(u ? Ge : Xe, Q, u ? Je : Ye);
      d[h] = Ke, S[h] = Ke - Q;
    }
    e.modifiersData[o] = S;
  }
}
const Cr = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Nr,
  requiresIfExists: ["offset"]
};
function kr(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function Br(t) {
  return t === L(t) || !$(t) ? We(t) : kr(t);
}
function $r(t) {
  var e = t.getBoundingClientRect(), r = ae(e.width) / t.offsetWidth || 1, o = ae(e.height) / t.offsetHeight || 1;
  return r !== 1 || o !== 1;
}
function Lr(t, e, r) {
  r === void 0 && (r = !1);
  var o = $(e), n = $(e) && $r(e), a = J(e), c = ie(t, n, r), p = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (o || !o && !r) && ((X(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  He(a)) && (p = Br(e)), $(e) ? (s = ie(e, !0), s.x += e.clientLeft, s.y += e.clientTop) : a && (s.x = qe(a))), {
    x: c.left + p.scrollLeft - s.x,
    y: c.top + p.scrollTop - s.y,
    width: c.width,
    height: c.height
  };
}
function Vr(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), o = [];
  t.forEach(function(a) {
    e.set(a.name, a);
  });
  function n(a) {
    r.add(a.name);
    var c = [].concat(a.requires || [], a.requiresIfExists || []);
    c.forEach(function(p) {
      if (!r.has(p)) {
        var s = e.get(p);
        s && n(s);
      }
    }), o.push(a);
  }
  return t.forEach(function(a) {
    r.has(a.name) || n(a);
  }), o;
}
function Ir(t) {
  var e = Vr(t);
  return Ce.reduce(function(r, o) {
    return r.concat(e.filter(function(n) {
      return n.phase === o;
    }));
  }, []);
}
function Wr(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function G(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++)
    r[o - 1] = arguments[o];
  return [].concat(r).reduce(function(n, a) {
    return n.replace(/%s/, a);
  }, t);
}
var Z = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', qr = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', pt = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function Hr(t) {
  t.forEach(function(e) {
    [].concat(Object.keys(e), pt).filter(function(r, o, n) {
      return n.indexOf(r) === o;
    }).forEach(function(r) {
      switch (r) {
        case "name":
          typeof e.name != "string" && console.error(G(Z, String(e.name), '"name"', '"string"', '"' + String(e.name) + '"'));
          break;
        case "enabled":
          typeof e.enabled != "boolean" && console.error(G(Z, e.name, '"enabled"', '"boolean"', '"' + String(e.enabled) + '"'));
          break;
        case "phase":
          Ce.indexOf(e.phase) < 0 && console.error(G(Z, e.name, '"phase"', "either " + Ce.join(", "), '"' + String(e.phase) + '"'));
          break;
        case "fn":
          typeof e.fn != "function" && console.error(G(Z, e.name, '"fn"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "effect":
          e.effect != null && typeof e.effect != "function" && console.error(G(Z, e.name, '"effect"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "requires":
          e.requires != null && !Array.isArray(e.requires) && console.error(G(Z, e.name, '"requires"', '"array"', '"' + String(e.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(e.requiresIfExists) || console.error(G(Z, e.name, '"requiresIfExists"', '"array"', '"' + String(e.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + e.name + '" modifier, valid properties are ' + pt.map(function(o) {
            return '"' + o + '"';
          }).join(", ") + '; but "' + r + '" was provided.');
      }
      e.requires && e.requires.forEach(function(o) {
        t.find(function(n) {
          return n.name === o;
        }) == null && console.error(G(qr, String(e.name), o, o));
      });
    });
  });
}
function Ur(t, e) {
  var r = /* @__PURE__ */ new Set();
  return t.filter(function(o) {
    var n = e(o);
    if (!r.has(n))
      return r.add(n), !0;
  });
}
function Fr(t) {
  var e = t.reduce(function(r, o) {
    var n = r[o.name];
    return r[o.name] = n ? Object.assign({}, n, o, {
      options: Object.assign({}, n.options, o.options),
      data: Object.assign({}, n.data, o.data)
    }) : o, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
var ft = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", _r = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", ct = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function lt() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return !e.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function Xr(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, o = r === void 0 ? [] : r, n = e.defaultOptions, a = n === void 0 ? ct : n;
  return function(p, s, l) {
    l === void 0 && (l = a);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ct, a),
      modifiersData: {},
      elements: {
        reference: p,
        popper: s
      },
      attributes: {},
      styles: {}
    }, y = [], O = !1, u = {
      state: f,
      setOptions: function(x) {
        var j = typeof x == "function" ? x(f.options) : x;
        m(), f.options = Object.assign({}, a, f.options, j), f.scrollParents = {
          reference: te(p) ? ue(p) : p.contextElement ? ue(p.contextElement) : [],
          popper: ue(s)
        };
        var P = Ir(Fr([].concat(o, f.options.modifiers)));
        if (f.orderedModifiers = P.filter(function(g) {
          return g.enabled;
        }), process.env.NODE_ENV !== "production") {
          var v = Ur([].concat(P, f.options.modifiers), function(g) {
            var S = g.name;
            return S;
          });
          if (Hr(v), q(f.options.placement) === Te) {
            var h = f.orderedModifiers.find(function(g) {
              var S = g.name;
              return S === "flip";
            });
            h || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var d = H(s), w = d.marginTop, R = d.marginRight, A = d.marginBottom, T = d.marginLeft;
          [w, R, A, T].some(function(g) {
            return parseFloat(g);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return E(), u.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!O) {
          var x = f.elements, j = x.reference, P = x.popper;
          if (!lt(j, P)) {
            process.env.NODE_ENV !== "production" && console.error(ft);
            return;
          }
          f.rects = {
            reference: Lr(j, he(P), f.options.strategy === "fixed"),
            popper: Ve(P)
          }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(g) {
            return f.modifiersData[g.name] = Object.assign({}, g.data);
          });
          for (var v = 0, h = 0; h < f.orderedModifiers.length; h++) {
            if (process.env.NODE_ENV !== "production" && (v += 1, v > 100)) {
              console.error(_r);
              break;
            }
            if (f.reset === !0) {
              f.reset = !1, h = -1;
              continue;
            }
            var d = f.orderedModifiers[h], w = d.fn, R = d.options, A = R === void 0 ? {} : R, T = d.name;
            typeof w == "function" && (f = w({
              state: f,
              options: A,
              name: T,
              instance: u
            }) || f);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Wr(function() {
        return new Promise(function(b) {
          u.forceUpdate(), b(f);
        });
      }),
      destroy: function() {
        m(), O = !0;
      }
    };
    if (!lt(p, s))
      return process.env.NODE_ENV !== "production" && console.error(ft), u;
    u.setOptions(l).then(function(b) {
      !O && l.onFirstUpdate && l.onFirstUpdate(b);
    });
    function E() {
      f.orderedModifiers.forEach(function(b) {
        var x = b.name, j = b.options, P = j === void 0 ? {} : j, v = b.effect;
        if (typeof v == "function") {
          var h = v({
            state: f,
            name: x,
            instance: u,
            options: P
          }), d = function() {
          };
          y.push(h || d);
        }
      });
    }
    function m() {
      y.forEach(function(b) {
        return b();
      }), y = [];
    }
    return u;
  };
}
var Yr = [ur, Sr, cr, Zt, Ar, Er, Cr, ir, Rr], zr = /* @__PURE__ */ Xr({
  defaultModifiers: Yr
});
function Gr(t) {
  return St("MuiPopper", t);
}
Ct("MuiPopper", ["root"]);
const Jr = ["anchorEl", "children", "component", "direction", "disablePortal", "modifiers", "open", "ownerState", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps"], Kr = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function Qr(t, e) {
  if (e === "ltr")
    return t;
  switch (t) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return t;
  }
}
function Re(t) {
  return typeof t == "function" ? t() : t;
}
function Ae(t) {
  return t.nodeType !== void 0;
}
function Zr(t) {
  return !Ae(t);
}
const eo = () => kt({
  root: ["root"]
}, Lt(Gr)), to = {}, ro = /* @__PURE__ */ V.forwardRef(function(e, r) {
  var o;
  const {
    anchorEl: n,
    children: a,
    component: c,
    direction: p,
    disablePortal: s,
    modifiers: l,
    open: f,
    ownerState: y,
    placement: O,
    popperOptions: u,
    popperRef: E,
    slotProps: m = {},
    slots: b = {},
    TransitionProps: x
  } = e, j = $e(e, Jr), P = V.useRef(null), v = Qe(P, r), h = V.useRef(null), d = Qe(h, E), w = V.useRef(d);
  et(() => {
    w.current = d;
  }, [d]), V.useImperativeHandle(E, () => h.current, []);
  const R = Qr(O, p), [A, T] = V.useState(R), [g, S] = V.useState(Re(n));
  V.useEffect(() => {
    h.current && h.current.forceUpdate();
  }), V.useEffect(() => {
    n && S(Re(n));
  }, [n]), et(() => {
    if (!g || !f)
      return;
    const k = (B) => {
      T(B.placement);
    };
    if (process.env.NODE_ENV !== "production" && g && Ae(g) && g.nodeType === 1) {
      const B = g.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && B.top === 0 && B.left === 0 && B.right === 0 && B.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let F = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: B
      }) => {
        k(B);
      }
    }];
    l != null && (F = F.concat(l)), u && u.modifiers != null && (F = F.concat(u.modifiers));
    const _ = zr(g, P.current, oe({
      placement: R
    }, u, {
      modifiers: F
    }));
    return w.current(_), () => {
      _.destroy(), w.current(null);
    };
  }, [g, s, l, f, u, R]);
  const D = {
    placement: A
  };
  x !== null && (D.TransitionProps = x);
  const Y = eo(), U = (o = c ?? b.root) != null ? o : "div", M = It({
    elementType: U,
    externalSlotProps: m.root,
    externalForwardedProps: j,
    additionalProps: {
      role: "tooltip",
      ref: v
    },
    ownerState: oe({}, e, y),
    className: Y.root
  });
  return /* @__PURE__ */ xe.jsx(U, oe({}, M, {
    children: typeof a == "function" ? a(D) : a
  }));
}), xt = /* @__PURE__ */ V.forwardRef(function(e, r) {
  const {
    anchorEl: o,
    children: n,
    container: a,
    direction: c = "ltr",
    disablePortal: p = !1,
    keepMounted: s = !1,
    modifiers: l,
    open: f,
    placement: y = "bottom",
    popperOptions: O = to,
    popperRef: u,
    style: E,
    transition: m = !1,
    slotProps: b = {},
    slots: x = {}
  } = e, j = $e(e, Kr), [P, v] = V.useState(!0), h = () => {
    v(!1);
  }, d = () => {
    v(!0);
  };
  if (!s && !f && (!m || P))
    return null;
  let w;
  if (a)
    w = a;
  else if (o) {
    const T = Re(o);
    w = T && Ae(T) ? Ze(T).body : Ze(null).body;
  }
  const R = !f && s && (!m || P) ? "none" : void 0, A = m ? {
    in: f,
    onEnter: h,
    onExited: d
  } : void 0;
  return /* @__PURE__ */ xe.jsx($t, {
    disablePortal: p,
    container: w,
    children: /* @__PURE__ */ xe.jsx(ro, oe({
      anchorEl: o,
      direction: c,
      disablePortal: p,
      modifiers: l,
      ref: r,
      open: m ? !P : f,
      placement: y,
      popperOptions: O,
      popperRef: u,
      slotProps: b,
      slots: x
    }, j, {
      style: oe({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: R
      }, E),
      TransitionProps: A,
      children: n
    }))
  });
});
process.env.NODE_ENV !== "production" && (xt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: Vt(i.oneOfType([Ee, i.object, i.func]), (t) => {
    if (t.open) {
      const e = Re(t.anchorEl);
      if (e && Ae(e) && e.nodeType === 1) {
        const r = e.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!e || typeof e.getBoundingClientRect != "function" || Zr(e) && e.contextElement != null && e.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: i.oneOfType([i.node, i.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([Ee, i.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: i.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: i.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: i.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: i.arrayOf(i.shape({
    data: i.object,
    effect: i.func,
    enabled: i.bool,
    fn: i.func,
    name: i.any,
    options: i.object,
    phase: i.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: i.arrayOf(i.string),
    requiresIfExists: i.arrayOf(i.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: i.shape({
    modifiers: i.array,
    onFirstUpdate: i.func,
    placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: i.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: ut,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: i.shape({
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: i.shape({
    root: i.elementType
  }),
  /**
   * @ignore
   */
  style: i.object,
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: i.bool
});
const oo = xt, no = ["components", "componentsProps", "slots", "slotProps"], ao = Nt(oo, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (t, e) => e.root
})({}), Et = /* @__PURE__ */ V.forwardRef(function(e, r) {
  var o;
  const n = Mt(), a = Bt({
    props: e,
    name: "MuiPopper"
  }), {
    components: c,
    componentsProps: p,
    slots: s,
    slotProps: l
  } = a, f = $e(a, no), y = (o = s == null ? void 0 : s.root) != null ? o : c == null ? void 0 : c.Root;
  return /* @__PURE__ */ xe.jsx(ao, oe({
    direction: n == null ? void 0 : n.direction,
    slots: {
      root: y
    },
    slotProps: l ?? p
  }, f, {
    ref: r
  }));
});
process.env.NODE_ENV !== "production" && (Et.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: i.oneOfType([Ee, i.object, i.func]),
  /**
   * Popper render function or node.
   */
  children: i.oneOfType([i.node, i.func]),
  /**
   * @ignore
   */
  component: i.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: i.shape({
    Root: i.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: i.shape({
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([Ee, i.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: i.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: i.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: i.arrayOf(i.shape({
    data: i.object,
    effect: i.func,
    enabled: i.bool,
    fn: i.func,
    name: i.any,
    options: i.object,
    phase: i.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: i.arrayOf(i.string),
    requiresIfExists: i.arrayOf(i.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * @ignore
   */
  ownerState: i.any,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: i.shape({
    modifiers: i.array,
    onFirstUpdate: i.func,
    placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: i.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: ut,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: i.shape({
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: i.shape({
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: i.bool
});
const yo = Et;
export {
  yo as M
};
